import { SVGProps } from '@components/Icon/types';

export const Reset = ({ fill = '#000', size = 24, ...props }: SVGProps) => (
  <svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <g transform="translate(3, 3)">
      <path
        d="M9.09996 0.1C4.13868 0.1 0.1 4.1387 0.1 9.1C0.1 14.0613 4.13868 18.1 9.09996 18.1C14.0612 18.1 18.0999 14.0613 18.0999 9.1C18.1014 8.9963 18.0822 8.89333 18.0436 8.7971C18.0049 8.70086 17.9475 8.61327 17.8747 8.53942C17.8018 8.46556 17.7151 8.40692 17.6194 8.36689C17.5237 8.32686 17.421 8.30625 17.3173 8.30625C17.2136 8.30625 17.1109 8.32686 17.0152 8.36689C16.9196 8.40692 16.8328 8.46556 16.76 8.53942C16.6872 8.61327 16.6297 8.70086 16.5911 8.7971C16.5524 8.89333 16.5332 8.9963 16.5347 9.1C16.5347 13.2154 13.2153 16.5348 9.09996 16.5348C4.98458 16.5348 1.66521 13.2154 1.66521 9.1C1.66521 4.9846 4.98458 1.66522 9.09996 1.66522C11.2427 1.66522 13.1663 2.56835 14.5216 4.01304H13.013C12.9093 4.01158 12.8063 4.03074 12.7101 4.06941C12.6138 4.10808 12.5263 4.16549 12.4524 4.23831C12.3786 4.31113 12.3199 4.3979 12.2799 4.49358C12.2398 4.58926 12.2192 4.69194 12.2192 4.79565C12.2192 4.89937 12.2398 5.00205 12.2799 5.09773C12.3199 5.19341 12.3786 5.28018 12.4524 5.35299C12.5263 5.42581 12.6138 5.48323 12.7101 5.5219C12.8063 5.56057 12.9093 5.57973 13.013 5.57826H17.3173V1.27391C17.3187 1.16927 17.2992 1.06541 17.2598 0.968464C17.2204 0.871519 17.1619 0.783461 17.0879 0.709498C17.0138 0.635535 16.9257 0.57717 16.8288 0.537855C16.7318 0.49854 16.6279 0.479072 16.5232 0.480605C16.3158 0.483644 16.1181 0.568908 15.9735 0.71766C15.8289 0.866412 15.7493 1.06648 15.7521 1.27391V3.04472C14.1049 1.2374 11.7325 0.1 9.09996 0.1Z"
        fill={fill}
        stroke={fill}
        strokeWidth="0.2"
      />
    </g>
  </svg>
);

export const ICON_NAME = 'reset';
